import React from 'react'
import { Link } from 'react-router-dom'
import Header from '../../headerone/Main'
import Breadcrumb from '../../Breadcrumb/Main'

const teachers = [

    {
        "Name": "Divya S  ",
        "Position": "Ph.D Scholar",
        "Batch": "Jan 2025",
        "AreasofResearch": "Industrial Psychology and Organisational Behaviour ",
        "GuideName": "Dr. Vaneet Kashyap",
        "GuideLink": "/dr-vaneet-kashyap",
        "Email": "hs25d002@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/pics/researchscholars/hss/2025/hs25d002.png"
    },

    {
        "Name": "Glory Narjinary  ",
        "Position": "Ph.D Scholar",
        "Batch": "Jan 2025",
        "AreasofResearch": "Development Economics",
        "GuideName": "Dr. Samyukta Bhupatiraju",
        "GuideLink": "/dr-samyukta-bhupatiraju",
        "Email": "hs25d003@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/pics/researchscholars/hss/2025/hs25d003.png"
    },

    {
        "Name": "Mohammad Ishaq Alikhan ",
        "Position": "Ph.D Scholar",
        "Batch": "July 2024",
        "AreasofResearch": "Organizational Behavior/Human Resource Management ",
        "GuideName": "Dr. Vaneet Kashyap",
        "GuideLink": "/dr-vaneet-kashyap",
        "Email": "hs24d501@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/pics/researchscholars/hss/2024/hs24d501.png"
    },

    {
        "Name": "Jayasimha Reddy Ankireddy",
        "Position": "Ph.D Scholar",
        "Batch": "July 2024",
        "AreasofResearch": "Organizational Behaviour",
        "GuideName": "Dr. Vaneet Kashyap",
        "GuideLink": "/dr-vaneet-kashyap",
        "Email": "hs24d502@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/pics/researchscholars/hss/2024/hs24d502.png"
    },

    {
        "Name": "Bhagyashree Moharana",
        "Position": "Ph.D Scholar",
        "Batch": "July 2024",
        "AreasofResearch": "Organizational Behavior / Human Resource Management",
        "GuideName": "Dr.Chandra Shekhar Bahinipati",
        "GuideLink": "/dr-chandra-sekhar-bahinipati",
        "Email": "hs24d503@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/pics/researchscholars/hss/2024/hs24d503.png"
    },

    {
        "Name": "Debarati Mondal",
        "Position": "Ph.D Scholar",
        "Batch": "July 2024",
        "AreasofResearch": "Philosophy of Education, Contemporary Indian Philosophy",
        "GuideName": "Dr. Bharath Kumar",
        "GuideLink": "/dr-bharath-kumar",
        "Email": "hs24d505@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/pics/researchscholars/hss/2024/hs24d505.png"
    },

    {
        "Name": "Gopika J Nair",
        "Position": "Ph.D Scholar",
        "Batch": "July 2024",
        "AreasofResearch": "Development Economics",
        "GuideName": "Dr. Rahul A Sirohi",
        "GuideLink": "/dr-rahul-a-sirohi",
        "Email": "hs24d506@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/pics/researchscholars/hss/2024/hs24d506.png"
    },

    {
        "Name": "Indrajit Maity",
        "Position": "Ph.D Scholar",
        "Batch": "July 2024",
        "AreasofResearch": "Critical Theory, Continental Philosophy",
        "GuideName": "Dr. Bharath Kumar",
        "GuideLink": "/dr-bharath-kumar",
        "Email": "hs24d507@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/pics/researchscholars/hss/2024/hs24d507.png"
    },

    {
        "Name": "Koppu Mounika",
        "Position": "Ph.D Scholar",
        "Batch": "July 2024",
        "AreasofResearch": "Philosophy",
        "GuideName": "Dr. Bharath Kumar",
        "GuideLink": "/dr-bharath-kumar",
        "Email": "hs24d508@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/pics/researchscholars/hss/2024/hs24d508.png"
    },

    {
        "Name": "Neha Keshari",
        "Position": "Ph.D Scholar",
        "Batch": "July 2024",
        "AreasofResearch": "Philosophy",
        "GuideName": "Dr. Bharath Kumar",
        "GuideLink": "/dr-bharath-kumar",
        "Email": "hs24d510@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/pics/researchscholars/hss/2024/hs24d510.png"
    },

    {
        "Name": "Shashwat Pandeya",
        "Position": "Ph.D Scholar",
        "Batch": "July 2024",
        "AreasofResearch": "Environmental Humanities",
        "GuideName": "Dr. Prabha Shankar Dwivedi",
        "GuideLink": "/dr-prabha-shankar-dwivedi",
        "Email": "hs24d512@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/pics/researchscholars/hss/2024/hs24d512.png"
    },

    {
        "Name": "Amitesh Verma",
        "Position": "Ph.D Scholar",
        "Batch": "Jan 2024",
        "AreasofResearch": "Organizational Behavior / Human Resource Management",
        "GuideName": "Dr. Vaneet Kashyap",
        "GuideLink": "/dr-vaneet-kashyap",
        "Email": "hs24d001@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/pics/researchscholars/hss/2024/Amitesh_Verma.png"
    },

    {
        "Name": "Khushboo Kumari",
        "Position": "Ph.D Scholar",
        "Batch": "Jan 2024",
        "AreasofResearch": "Gender Studies",
        "GuideName": "Dr. Shailendra Kumar Singh",
        "GuideLink": "/dr-shailendra-kumar-singh",
        "Email": " hs24d002@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/pics/researchscholars/hss/2024/Khushboo_Kumari.png"
    },
    {
        "Name": "Pushpita Panda",
        "Position": "Ph.D Scholar",
        "Batch": "Jan 2024",
        "AreasofResearch": "Comparative Literature",
        "GuideName": "Dr. Prabha Shankar Dwivedi",
        "GuideLink": "/dr-prabha-shankar-dwivedi",
        "Email": "hs24d005@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/pics/researchscholars/hss/2024/Pushpita_Panda.png"
    },

    {
        "Name": "Shiva Muthukumar",
        "Position": "Ph.D Scholar",
        "Batch": "Jan 2024",
        "AreasofResearch": "Applications of AI and ML in Supply Chain Risk Management",
        "GuideName": "Dr. Vishnu C. Rajan",
        "GuideLink": "/dr-vishnu-c-rajan",
        "Email": "hs24d006@iittp.ac.in",
        "Image": "https://files.iittp.ac.in/images/pics/researchscholars/hss/2024/Shiva_Muthukumar.png"
    },
    
 

        {
            "Name": "Anamika Halder",
            "Position": "Ph.D Scholar",
            "Batch": "July 2023",
            "AreasofResearch": "Sustainability, Public Policy and Governance: Cultural Heritage in Ganges Delta",
            "GuideName": "Dr. Shailendra Kumar Singh",
            "GuideLink": "/dr-shailendra-kumar-singh",
            "Email": "hs23d501@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/hss/Anamika_Halder.png"
        },
        {
            "Name": "Kanupriya Pandey",
            "Position": "Ph.D Scholar",
            "Batch": "July 2023",
            "AreasofResearch": "English",
            "GuideName": "Dr. Prabha Shankar Dwivedi",
            "GuideLink": "/dr-prabha-shankar-dwivedi",
            "Email": "hs23d503@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/hss/Kanupriya.png"
        },
        // {
        //     "Name": "Kshirod Kumar Mishra",
        //     "Position": "Ph.D Scholar",
        //     "Batch": "July 2023",
        //     "AreasofResearch": "Energy Economics",
        //     "GuideName": "Dr. Chandra Shekhar Bahinipati",
        //     "GuideLink": "/dr-chandra-sekhar-bahinipati",
        //     "Email": "hs23d504@iittp.ac.in",
        //     "Image": "https://files.iittp.ac.in/pics/researchscholars/hss/Kshirod.png"
        // },
        {
            "Name": "Mohit Kumar Aryan",
            "Position": "Ph.D Scholar",
            "Batch": "July 2023",
            "AreasofResearch": "Masculinity Studies and Literature",
            "GuideName": "Dr. Shailendra Kumar Singh",
            "GuideLink": "/dr-shailendra-kumar-singh",
            "Email": "hs23d505@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/hss/Mohit_Kumar.png"
        },
        {
            "Name": "Raajkamal G",
            "Position": "Ph.D Scholar",
            "Batch": "July 2023",
            "AreasofResearch": "Disability and Accessibility: Public policy",
            "GuideName": "Dr. Varun Varghese",
            "GuideLink": "/dr-varun-varghese",
            "Email": "hs23d506@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/hss/Raajkamal_G.png"
        },
        {
            "Name": "Sangita Singh",
            "Position": "Ph.D Scholar",
            "Batch": "July 2023",
            "AreasofResearch": "English",
            "GuideName": "Dr. Prabha Shankar Dwivedi",
            "GuideLink": "/dr-prabha-shankar-dwivedi",
            "Email": "hs23d507@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/hss/Sangita_Singh.png"
        },
        {
            "Name": "Supanwita Bar",
            "Position": "Ph.D Scholar",
            "Batch": "July 2023",
            "AreasofResearch": "Sustainability, Public Policy and Governance: Ganges Delta",
            "GuideName": "Dr. Bharath Kumar",
            "GuideLink": "/dr-bharath-kumar",
            "Email": "hs23d508@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/hss/Supanwita_Bar.png"
        },
        {
            "Name": "Yashpal Luniwal",
            "Position": "Ph.D Scholar",
            "Batch": "July 2023",
            "AreasofResearch": "Economics",
            "GuideName": "Dr. Chandra Shekhar Bahinipati",
            "GuideLink": "/dr-chandra-sekhar-bahinipati",
            "Email": "hs23d509@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/hss/Yashpal_Luniwal.png"
        },
        {
            "Name": "Aiswarya Pradeep",
            "Position": "Ph.D Scholar",
            "Batch": "July 2022",
            "AreasofResearch": "Gender, Crime and Popular media",
            "GuideName": "Dr. Shailendra Kumar Singh",
            "GuideLink": "/dr-shailendra-kumar-singh",
            "Email": "hs22d501@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/hss/Aiswariya.jpg"
        },
        {
            "Name": "Prithu Halder",
            "Position": "Ph.D Scholar",
            "Batch": "July 2022",
            "AreasofResearch": "Magical Realism, Avant Garde, World Cinema",
            "GuideName": "Dr. Bibhuti Mary Kachhap",
            "GuideLink": "/dr-bibhuti-mary-kachhap",
            "Email": "hs22d502@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/hss/Prithu.jpg"
        },
        {
            "Name": "Malavika",
            "Position": "Ph.D Scholar",
            "Batch": "Jan 2022",
            "AreasofResearch": "Asexuality, Gender and Sexuality Studies, Film Studies",
            "GuideName": "Dr. Bibhuti Mary Kachhap",
            "GuideLink": "/dr-bibhuti-mary-kachhap",
            "Email": "hs22d001@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/hss/Malavika HSS.jpg"
        },
        {
            "Name": "Ann Mary Thomas",
            "Position": "Ph.D Scholar",
            "Batch": "July 2019",
            "AreasofResearch": "Philosophy",
            "GuideName": "Dr. Bharath Kumar",
            "GuideLink": "/dr-bharath-kumar",
            "Email": "hs19d501@iittp.ac.in",
            "Image": "https://files.iittp.ac.in/pics/researchscholars/hss/Ann Mary Thomas.jpg"
        },
        // {
        //     "Name": "G Venkatesh",
        //     "Position": "Ph.D Scholar",
        //     "Batch": "July 2019",
        //     "AreasofResearch": "Finance, Corporate Governance",
        //     "GuideName": "Dr. Saranya Kshatriya & Dr. Shashank Bansal",
        //     "Email": "hs19d502@iittp.ac.in",
        //     "Image": "https://files.iittp.ac.in/pics/researchscholars/hss/G VENKATESH.jpg"
        // },
        // {
        //     "Name": "Neelam Nakra",
        //     "Position": "Ph.D Scholar",
        //     "Batch": "July 2019",
        //     "AreasofResearch": "Organization Behavior/Human Resource Management",
        //     "GuideName": "Dr. Vaneet Kashyap",
        //     "GuideLink": "/dr-vaneet-kashyap",
        //     "Email": "hs19d503@iittp.ac.in",
        //     "Image": "https://files.iittp.ac.in/pics/researchscholars/hss/neelam.jpg"
        // },
        // {
        //     "Name": "Monalisa Singh",
        //     "Position": "Ph.D Scholar",
        //     "Batch": "Jan 2019",
        //     "AreasofResearch": "Development Economics",
        //     "GuideName": "Dr. Rahul A. Sirohi",
        //     "GuideLink": "/dr-rahul-a-sirohi",
        //     "Email": "hs19d001@iittp.ac.in",
        //     "Image": "https://files.iittp.ac.in/pics/researchscholars/hss/monalisa_hs19d001.jpg"
        // },
        // {
        //     "Name": "N.Srikanth",
        //     "Position": "Ph.D Scholar",
        //     "Batch": "Jan 2019",
        //     "AreasofResearch": "Cultural Studies",
        //     "GuideName": "Dr. V. Vamshi Krishna Reddy",
        //     "GuideLink": "/dr-v-vamshi-krishna-reddy",
        //     "Email": "hs19d002@iittp.ac.in",
        //     "Image": "https://files.iittp.ac.in/pics/researchscholars/hss/N.Srikanth_HS19D002.JPG"
        // }
]



function Main() {

    return (
        <>
            <Header />
            <Breadcrumb title="Home" subtitle="Humanities and Social Sciences" />
            <section className="team-area fix p-relative pt-120 pb-80">
                 
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 p-relative">
                            <div className="section-title center-align mb-50 text-center wow fadeInDown animated" data-animation="fadeInDown" data-delay=".4s">
                                <h5>
                                    <i className="fal fa-graduation-cap" /> Research Scholars
                                </h5>
                                <h2>Humanities and Social Sciences</h2>
                            </div>
                        </div>
                    </div>
                    <div className="row">
                        {teachers.map((teacher, index) => (
       

                            <div key={index} className="col-xl-3 col-md-6 col-sm-6">
                                <div className="single-team mb-40">
                                    <div className="team-thumb">
                                        <div className="brd">
                                            <Link to="#">
                                                <img src={teacher.Image} alt="img" />
                                            </Link>
                                        </div>
                                    </div>
                                    <div className="team-info">
                                        <h4>
                                            <Link to={teacher.namelink}>{teacher.Name}</Link>
                                        </h4>
                                       
                                        <div className="text-dark c-lineheight2">
                                            <p > <i className="fal fa-graduation-cap me-2" />{teacher.Position}</p>
                                            <p className="text-dark">{teacher.position2}</p>
                                            <p className="text-dark">Batch : {teacher.Batch}</p>
                                            <p className="text-dark">Areas of Research : {teacher.AreasofResearch}</p>
                                            
                                            {/* Parse the HTML content and extract text */}
                                            
                                            <p className="text-dark">Guide: <Link className="text-maroon" to={teacher.GuideLink} target="_blank" > {teacher.GuideName}</Link> </p>

                                            {(teacher.CoGuideName !== undefined && teacher.CoGuideName !== "") && (
                                                <p className="text-dark">Co-Guide: <a className="text-maroon" href={teacher.CoGuideLink} target="_blank" >{teacher.CoGuideName}</a></p>
                                            )}

                                            

                                            {/* <p className="text-orange"><i className="fal fa-envelope  me-2"></i> <Link to={teacher.Email} target="_blank" className="btn btn-primary">{teacher.Email}</Link></p> */}
                                            <p className="text-dark"><i className="fal fa-envelope  me-1"></i> Email : {teacher.Email}</p>
                                        </div>                                       
                                    </div>
                                </div>
                            </div>
                        ))}
                    </div>
                </div>
            </section>
        </>
    )
}

// // Function to parse HTML content and extract text
// function parseHTML(htmlString) {
//     const tempElement = document.createElement('div');
//     tempElement.innerHTML = htmlString;
//     return tempElement.textContent || tempElement.innerHTML || '';
// }


export default Main